import { render, staticRenderFns } from "./studentResults.vue?vue&type=template&id=2c568e11&"
import script from "./studentResults.vue?vue&type=script&lang=js&"
export * from "./studentResults.vue?vue&type=script&lang=js&"
import style0 from "./studentResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports